import { deepCopy, firestoreTimestampToDate, isDate } from "../utils/obejct-diff";
import { NetworkConstants } from "./network.constants";
import { UserRoles } from "./user.data";


export const fallbackSettingsMap: Map<string, IContextSetting | undefined> = new Map([
  [NetworkConstants.SETTING_COLLECTIVE_SPECIES, {
    identifier: NetworkConstants.SETTING_COLLECTIVE_SPECIES,
    values: [
      { names: { de: "Krähe" }, sortOrder: 1, identifier: "Krähe" },
      { names: { de: "Taube" }, sortOrder: 1, identifier: "Taube" },
      { names: { de: "Fasan" }, sortOrder: 1, identifier: "Fasan" },
    ]
  }],
  [NetworkConstants.SETTING_GR_LOCATION, {
    identifier: NetworkConstants.SETTING_GR_LOCATION,
    values: [
      {
        "identifier": "wildkammer",
        "title": "Wildkammer"
      }
    ]
  }],
  [NetworkConstants.SETTING_GR_STATUS, {
    identifier: NetworkConstants.SETTING_GR_STATUS,
    values: [
      {
        "identifier": "erfasst",
        "title": "erfasst"
      },
      {
        "identifier": "in Bergung",
        "title": "in Bergung"
      },
      {
        "identifier": "in Wildkammer",
        "title": "in Wildkammer"
      },
      {
        "identifier": "Verwertung",
        "title": "in Verwertung"
      },
      {
        "identifier": "verworfen",
        "title": "verworfen"
      }
    ]
  }],
  [NetworkConstants.SETTING_GEO_TYPE, {
    identifier: NetworkConstants.SETTING_GEO_TYPE,
    values: [
      { identifier: "hochsitz", title: "Hochsitz", sortOrder: 0 },
      { identifier: "drueckjagdbock", title: "Drückjagdbock", sortOrder: 0 },
      { identifier: "drueckjagdstand", title: "Drückjagdstand", sortOrder: 0 },
      { identifier: "erdsitz", title: "Erdsitz", sortOrder: 0 },
      { identifier: "kanzel.geschlossen", title: "Kanzel (geschlossen)", sortOrder: 0 },
      { identifier: "kanzel.offen", title: "Kanzel (offen)", sortOrder: 0 },
      { identifier: "kanzel.schlafkanzel", title: "Kanzel (schlaf~)", sortOrder: 0 },
      { identifier: "kirrung", title: "Kirrung", sortOrder: 0 },
      { identifier: "leiter.offen.baum", title: "Leiter (offen, am Baum)", sortOrder: 0 },
      { identifier: "leiter.offen.frei", title: "Leiter (offen, freistehend)", sortOrder: 0 },
      { identifier: "salzlecke", title: "Salzlecke", sortOrder: 0 },
      { identifier: "wildkammer", title: "Wildkammer", sortOrder: 0 },
    ]
  }],

  [NetworkConstants.SETTING_GEO_LINE_TYPES, {
    identifier: NetworkConstants.SETTING_GEO_LINE_TYPES,
    values: [
      { identifier: "pirschweg", title: "Pirschweg2", sortOrder: 0 },
      { identifier: "wildwechsel", title: "Wildwechsel", sortOrder: 0 },
      { identifier: "fahrweg", title: "Fahrweg", sortOrder: 0 },
      { identifier: "fahrweg 1", title: "Fahrweg 1", sortOrder: 0 },
      { identifier: "fahrweg 2", title: "Fahrweg 2", sortOrder: 0 },
    ]
  }],


  [NetworkConstants.SETTING_HUNTING_METHODS, {
    identifier: NetworkConstants.SETTING_HUNTING_METHODS,
    values: [
      { identifier: "hideHunt", title: "Ansitzjagd", sortOrder: 0 },
      { identifier: "drivenHunt", title: "Drückjagd", sortOrder: 0 },
      { identifier: "stalking", title: "Pirschjagd", sortOrder: 0 },
      { identifier: "fallowGameAccident", title: "Fallwild: Unfall", sortOrder: 0 },
      { identifier: "fallowGameMisc", title: "Fallwild: Sonstige", sortOrder: 0 },
      { identifier: "chopper", title: "Mähverlust", sortOrder: 0 },
    ]
  }],
  [NetworkConstants.SETTING_LAB_SAMPLE_LOCATION, {
    identifier: NetworkConstants.SETTING_LAB_SAMPLE_LOCATION,
    values: [
      {
        "identifier": "wildkammer",
        "title": "Wildkammer"
      },
      {
        "identifier": "labor",
        "title": "Labor"
      }
    ]
  }],
  [NetworkConstants.SETTING_LAB_SAMPLE_STATUS, {
    identifier: NetworkConstants.SETTING_LAB_SAMPLE_STATUS,
    values: [
      {
        "identifier": "erfasst",
        "title": "erfasst"
      }
    ]
  }],
  [NetworkConstants.SETTING_LAB_SAMPLE_TYPE, {
    identifier: NetworkConstants.SETTING_LAB_SAMPLE_TYPE,
    values: [
      {
        "identifier": "trichinenTestGewebe",
        "title": "Trichinen Test Gewebe"
      },
      {
        "identifier": "bluttestAujeczky",
        "title": "Bluttest Aujeczky"
      },
      {
        "identifier": "bluttestAllgemein",
        "title": "Bluttest Allgemein"
      }
    ]
  }],
  [NetworkConstants.SETTING_GR_MEAT_QUALITY, {
    identifier: NetworkConstants.SETTING_GR_MEAT_QUALITY,
    values: [
      { identifier: "Gut", title: "Gut", sortOrder: 0, comment: null }
    ]
  }],
  [NetworkConstants.SETTING_GR_SHOT_QUALITY, {
    identifier: NetworkConstants.SETTING_GR_SHOT_QUALITY,
    values: [
      { identifier: "Gut", title: "Gut", sortOrder: 0, comment: null }
    ]
  }],
  [NetworkConstants.SETTING_SPECIES, {
    identifier: NetworkConstants.SETTING_SPECIES,
    values: [
      {
        "ageClassesFemale": {
          "de": [
            "Kalb",
            "Schmaltier",
            "Alttier"
          ]
        },
        "ageClassesMale": {
          "de": [
            "Kalb",
            "Schmalspießer",
            "Hirsch"
          ]
        },
        "iconName": "icnRotwild",
        "identifier": "Rotwild",
        "names": {
          "de": "Rotwild"
        },
        "sortOrder": 1
      },
      {
        "ageClassesFemale": {
          "de": [
            "Kalb",
            "Schmaltier",
            "Alttier"
          ]
        },
        "ageClassesMale": {
          "de": [
            "Kalb",
            "Schmalspießer",
            "Hirsch"
          ]
        },
        "iconName": "icnDamwild",
        "identifier": "Damwild",
        "names": {
          "de": "Damwild"
        },
        "sortOrder": 2
      },
      {
        "ageClassesFemale": {
          "de": [
            "Lamm",
            "Schmalschaf",
            "Altschaf"
          ]
        },
        "ageClassesMale": {
          "de": [
            "Lamm",
            "Jährling",
            "Widder"
          ]
        },
        "iconName": "icnMuffelwild",
        "identifier": "Muffelwild",
        "names": {
          "de": "Muffelwild"
        },
        "sortOrder": 4
      },
      {
        "ageClassesFemale": {
          "de": [
            "Rickenkitz",
            "Schmalreh",
            "Ricke"
          ]
        },
        "ageClassesMale": {
          "de": [
            "Bockkitz",
            "Jährling",
            "Bock"
          ]
        },
        "iconName": "icnRehwild",
        "identifier": "Rehwild",
        "names": {
          "de": "Rehwild"
        },
        "sortOrder": 6
      },
      {
        "ageClassesFemale": {
          "de": [
            "Frischlingsbache",
            "Überläuferbache",
            "Bache"
          ]
        },
        "ageClassesMale": {
          "de": [
            "Frischlingskeiler",
            "Überläuferkeiler",
            "Keiler"
          ]
        },
        "iconName": "icnSchwarzwild",
        "identifier": "Schwarzwild",
        "names": {
          "de": "Schwarzwild"
        },
        "sortOrder": 5
      },
      {
        "ageClassesFemale": {
          "de": [
            "Kalb",
            "Schmaltier",
            "Alttier"
          ]
        },
        "ageClassesMale": {
          "de": [
            "Kalb",
            "Schmalspießer",
            "Hirsch"
          ]
        },
        "iconName": "icnSikawild",
        "identifier": "Sikawild",
        "names": {
          "de": "Sikawild"
        },
        "sortOrder": 3
      },
      {
        "ageClassesFemale": {
          "de": [
            "Jungfuchsfähe",
            "Fähe"
          ]
        },
        "ageClassesMale": {
          "de": [
            "Jungfuchsrüde",
            "Rüde"
          ]
        },
        "iconName": "icnFuchs",
        "identifier": "Fuchs",
        "names": {
          "de": "Fuchs"
        },
        "sortOrder": 7
      },
      {
        "ageClassesFemale": {
          "de": [
            "Jungdachsfähe",
            "Dachsfähe"
          ]
        },
        "ageClassesMale": {
          "de": [
            "Jungdachsrüde",
            "Dachsbär"
          ]
        },
        "iconName": "DIWIMA_Icons_Wildarten_Dachs",
        "identifier": "Dachs",
        "names": {
          "de": "Dachs"
        },
        "sortOrder": 8
      },
      {
        "ageClassesFemale": {
          "de": [
            "Waschbär (adult)"
          ]
        },
        "ageClassesMale": {
          "de": [
            "Jungtier"
          ]
        },
        "iconName": "DIWIMA_Icons_Wildarten_Waschbaer",
        "identifier": "Waschbär",
        "names": {
          "de": "Waschbär"
        },
        "sortOrder": 9
      },
      {
        "ageClassesFemale": {
          "de": [
            "Jungnutria Metze",
            "Nutria Metze"
          ]
        },
        "ageClassesMale": {
          "de": [
            "Jungnutria männlich",
            "Nutria männlich"
          ]
        },
        "iconName": "icnNutria",
        "identifier": "Nutria",
        "names": {
          "de": "Nutria"
        },
        "sortOrder": 10
      },
      {
        "ageClassesFemale": {
          "de": [
            "Alttier"
          ]
        },
        "ageClassesMale": {
          "de": [
            "Jungtier"
          ]
        },
        "iconName": "DIWIMA_Icons_Wildarten_Sonstige",
        "identifier": "Sonstige",
        "names": {
          "de": "Sonstige"
        },
        "sortOrder": 11
      }
    ]
  }],
  [NetworkConstants.SETTING_UTILIZATION_OPTION, {
    identifier: NetworkConstants.SETTING_UTILIZATION_OPTION,
    values: [
      {
        "identifier": "eigen",
        "title": "Eigenverwertung"
      }
    ]
  }],
  [NetworkConstants.SETTING_TROPY_TYPE, {
    identifier: NetworkConstants.SETTING_TROPY_TYPE,
    values: [
      {
        "identifier": "antlers",
        "title": "Geweih"
      },
      {
        "identifier": "fur",
        "title": "Fell"
      }
    ]
  }],
  [NetworkConstants.SETTING_GEO_USAGE_STATUS, {
    identifier: NetworkConstants.SETTING_GEO_USAGE_STATUS,
    values: [
      {
        "identifier": "frei",
        "title": "frei zur Verwendung"
      },
      {
        "identifier": "ausnahmerecht",
        "title": "Verwendung nur mit Ausnahmrecht"
      },
      {
        "identifier": "nichtPositioniert",
        "title": "vorübergehend nicht positioniert"
      },
      {
        "identifier": "gesperrt.instandhaltung",
        "title": "gesperrt - Instandhaltung ausstehend"
      },
      {
        "identifier": "gesperrt",
        "title": "gesperrt - bis auf weiteres"
      },
      {
        "identifier": "vernichtet",
        "title": "vernichtet"
      }
    ]
  }],
  [NetworkConstants.SETTING_EVENT_INVITATION_SITE_REFERRAL, {
    identifier: NetworkConstants.SETTING_EVENT_INVITATION_SITE_REFERRAL,
    values: []
  }],
  [NetworkConstants.SETTING_READOUT_GROUPS, {
    identifier: NetworkConstants.SETTING_READOUT_GROUPS,
    values: [
      {
        "identifier": "Jagdgast",
        "title": "Jagdgast"
      },
      {
        "identifier": "Jagdhelfer",
        "title": "Jagdhelfer"
      }
    ]
  }]
])

async function getContextSettings(firestore: any, contextId: string): Promise<Map<string, IContextSetting | undefined>> {
  return new Promise(async (resolve, reject) => {
    try {
      var contextSettings: any[] = []
      const settingsQuery = await firestore
        .collection(NetworkConstants.COLLECTION_CONTEXT)
        .doc(contextId)
        .collection(NetworkConstants.COLLECTION_SETTINGS)
        .get().toPromise()

      let map = new Map()
      if (!settingsQuery.empty) {
        settingsQuery.forEach((doc: any) => {
          if (doc.exists) {
            const data = doc.data()
            if (data.values === "" || !data.values) {
              data.values = [];
            }
            map.set(data.identifier, data as IContextSetting | undefined)
            contextSettings.push(doc.data())
          }
        })
      }
      resolve(map)
    } catch (error) {
      console.log(error)
      reject(error)
    }
  })
}

async function getContextModules(firestore: any, contextId: string): Promise<Map<string, IContextSetting | undefined>> {
  return new Promise(async (resolve, reject) => {
    try {
      var contextModules: any[] = []
      const modulesQuery = await firestore
        .collection(NetworkConstants.COLLECTION_CONTEXT)
        .doc(contextId)
        .collection(NetworkConstants.COLLECTION_MODULES)
        .get().toPromise()

      let map = new Map()
      if (!modulesQuery.empty) {
        modulesQuery.forEach((doc: any) => {
          if (doc.exists) {
            const data = doc.data()
            const identifier = doc.id
            map.set(identifier, data as IContextSetting | undefined)
            contextModules.push(doc.data())
          }
        })
      }
      resolve(map)
    } catch (error) {
      reject(error)
    }
  })
}

export class Context {

  public settingsMap: Map<string, IContextSetting | undefined> = fallbackSettingsMap
  public modulesMap: Map<string, IContextModule | undefined> = new Map([])
  public _structureVersion: string | undefined = undefined
  public roles: string[] | undefined = undefined
  public demoContext: boolean | undefined = undefined
  public testDataCreated: Date | undefined = undefined
  public huntingEventManagement: boolean | undefined = undefined
  public subContextIds?: string[] = undefined
  public superContext?: boolean = undefined
  public superContextIds?: string[] = undefined
  public testData?: boolean = undefined

  constructor(
    public identifier: string,
    public name: string
  ) { }

  setFromAny(element: any) {
    const { _structureVersion, roles, demoContext, testDataCreated, huntingEventManagement,
      subContextIds, superContext, superContextIds, testData } = element
    this._structureVersion = _structureVersion ? _structureVersion : this._structureVersion
    this.roles = roles ? roles : this.roles
    this.demoContext = (demoContext != null) ? demoContext : this.demoContext
    this.testDataCreated = testDataCreated ? isDate(testDataCreated) ? testDataCreated : firestoreTimestampToDate(testDataCreated) : this.testDataCreated
    this.huntingEventManagement = huntingEventManagement ? huntingEventManagement : this.huntingEventManagement
    this.subContextIds = subContextIds ? subContextIds : this.subContextIds
    this.superContext = superContext ? superContext : this.superContext
    this.superContextIds = superContextIds ? superContextIds : this.superContextIds
    this.testData = testData ? testData : this.testData
  }

  getContextSettings(firestore: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const map = await getContextSettings(firestore, this.identifier!)
        map.forEach((value, key) => {
          if (value) { this.settingsMap.set(key, value) }
        })
        resolve(map)
      } catch (error) {
        reject(error)
      }
    })
  }

  getContextModules(firestore: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const map = await getContextModules(firestore, this.identifier!)
        map.forEach((value, key) => { this.modulesMap.set(key, value) })
        resolve(undefined)
      } catch (error) {
        reject(error)
      }
    })
  }
}

// export enum UserRole {
//   ADMIN = "admin", REVIERLEITER = "revierLeiter", 
//   USER = "user", ANSTELLER = "ansteller", 
//   HUNTER = "hunter", JAGDLEITER = "jagdLeiter"
// }

export class ContextMembership {

  public settingsMap: Map<string, IContextSetting | undefined> = fallbackSettingsMap
  public modulesMap: Map<string, IContextModule | undefined> = new Map(undefined)
  identifier: string|undefined
  contextName: string|undefined
  _structureVersion: string | undefined
  roles: string[] | undefined
  additionalRights: string[] | undefined
  creationDate: Date | undefined
  updateTimestamp: Date | undefined
  huntingEventManagement: boolean | undefined
  email?:string | undefined
  // logoUrl: string|undefined
    invitationState?: string | undefined // error, pendingInvite, pendingRegistration, accepted
    oobCode?: string | undefined
    userId?: string | undefined
  public subContextIds?: string[] = undefined
  public superContext?: boolean = undefined
  public superContextIds?: string[] = undefined
  public testData?: boolean = undefined

  constructor() { }

  setFromAny(element: any) {
    const { _structureVersion, roles, additionalRights, creationDate, updateTimestamp, huntingEventManagement, identifier, contextName, name, contextId,invitationState,userId,email,oobCode,
      subContextIds, superContext, superContextIds, testData } = element
    this._structureVersion = _structureVersion ? _structureVersion : this._structureVersion
    this.identifier = identifier ? identifier : contextId ? contextId : this.identifier
    this.contextName = contextName ? contextName : name ? name : this.contextName
    this.roles = roles ? roles : this.roles
    this.additionalRights = additionalRights ? additionalRights : this.additionalRights
    this.updateTimestamp = creationDate ? isDate(creationDate) ? creationDate : firestoreTimestampToDate(creationDate) : this.creationDate
    this.creationDate = updateTimestamp ? isDate(updateTimestamp) ? updateTimestamp : firestoreTimestampToDate(updateTimestamp) : this.updateTimestamp
    this.huntingEventManagement = huntingEventManagement ? huntingEventManagement : this.huntingEventManagement
    this.invitationState = invitationState ? invitationState : this.invitationState
    this.userId = userId ? userId : this.userId
    this.email = email ? email : this.email
    this.oobCode = oobCode ? oobCode : this.oobCode
    this.subContextIds = subContextIds ? subContextIds : this.subContextIds
    this.superContext = superContext ? superContext : this.superContext
    this.superContextIds = superContextIds ? superContextIds : this.superContextIds
    this.testData = testData ? testData : this.testData
  }

  public static setFromAny(element: any): ContextMembership {
    const contextMembership = new ContextMembership()
    contextMembership.setFromAny(element)
    return contextMembership
  }

  isRoleMember(role: UserRoles): boolean {
    if (!this.roles) return false
    return this.roles?.includes(role.toString()) ? true : false
  }

  getContextSettings(firestore: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (!this.identifier) reject('No contextId provided')
      try {
        const map = await getContextSettings(firestore, this.identifier!)
        map.forEach((value, key) => {
          if (value) { this.settingsMap.set(key, deepCopy(value)) }
        })
        resolve(map)
      } catch (error) {
        reject(error)
      }
    })
  }

  getContextModules(firestore: any): Promise<void> {
    return new Promise(async (resolve, reject) => {
      if (!this.identifier) reject('No contextId provided')
      try {
        const map = await getContextModules(firestore, this.identifier!)
        map.forEach((value, key) => { this.modulesMap.set(key, value) })
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key 
     */
  replacerFn(key: string) {
    if (key == "settingsMap") return false
    else return true
  }

  public toString(): string {
    return JSON.stringify(this)
  }
}

export interface IContextSetting {
  // _structureVersion?: string
  contextId?: string
  identifier: string
  updateTimestamp?: Date
  values: any[] //ConfigurationItem[]|ISpecies[]
}

export interface ISubContextSetting {
  // _structureVersion?: string
  contextId?: string
  data?: any
}

export interface IContextModule {
  // _structureVersion?: string
  contextId?: string
  identifier?: string
  updateTimestamp?: Date
}

export interface ConfigurationItem {
  identifier: string
  title?: string
  sortOrder?: Number
  sortIndex?: Number
  color?: string
  comment?: string
  displayOptions?: DisplayOptions,
  personId?: string,
  personName?: string,
  personPickerMode?: string,
  ageClassesFemale?: { de: string[] },
  ageClassesMale?: { de: string[] },
  qualityClasses?: { de: string[] },
  names?: { de: string },
  iconName?: string,
  colorName?:string
  optionGroup?:string,
}

export interface SiteReferralItem {
  identifier: string
  title: string
  siteReferralURL: string   // https://.../ <- eventId
  useAsDefault: boolean  // if nothing is specified on the event, default is taken
}

export interface DisplayOptions {
  additionalObjects?: boolean
  heading?: boolean
  shotRanges?: boolean
  usageInformation?: boolean
  testInterval?: boolean
  notificationChannel?: boolean
}

// interface ISpecies {
//     _structureVersion: string
//     contextId?: string 
//     identifier: string
//     updateTimestamp: Date
//     values: SpeciesValues[]
// }

export interface SpeciesValues {
  ageClassesFemale: { de: string[] },
  ageClassesMale: { de: string[] },
  identifier: string
  iconName: string
  names: LanguageOptions
}

export interface LanguageOptions {
  de: string
}

export interface IContext {
  identifier: string
  name: string
  subContextIds?: string[]
  superContext?: boolean
  superContextIds?: string[]
  testData?: boolean
  testDataCreated?: any
  huntingEventManagement?: boolean
}


export interface GeoObjLineTypesData {
  identifier: string;
  title?: string;
  sortIndex?: Number;
  lineColorName?: string;
  comment?: string;
  displayOptions?: DisplayOptions;
  lineWidth?: Number;
}

export interface GeoObjPolygonTypesData {
  identifier: string;
  title?: string;
  sortIndex?: Number;
  fillColorName?: string;
  fillOpacity?: Number;
  displayOptions?: DisplayOptions;
  borderWidth?: Number;
  borderColorName?: string;
}

export interface GeoObjCategoryData {
  identifier: string;
  title?: string;
  titles?: object;
  sortIndex?: Number;
}

export interface usRolesDataAccess {
  collection: string
  filters?: string[]
  rights: string[]
}

export interface userRolesData {
  identifier: string;
  title?: string;
  titles?: string[];
  rights?: string[];
  appAccess?: string[];
  dataAccess?: usRolesDataAccess[];
  sortIndex?: Number
}


export const rightsPerRole = {
  revierLeiter: {
    cockpit: {
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`start`]:{//defaultRoles
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`dashboard`]:{//cockpit/:identifier/
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`dashcadenza`]:{
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`contextsettings`]:{
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`objects`]:{
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`invitation`]:{
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`statistics`]:{
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`map`]:{
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [NetworkConstants.COLLECTION_GAMERECORD]: {
      C:true,
      R:true,
      U:true,
      D:true,
      E:true,
      I:true
    },
    [NetworkConstants.COLLECTION_POI]: {
      C:true,
      R:true,
      U:true,
      D:true,
      E:true,
      I:true
    },
    [NetworkConstants.COLLECTION_WORK_ORDER]: {
      C:true,
      R:true,
      U:true,
      D:true,
      E:true,
      I:true
    },
    [NetworkConstants.COLLECTION_USER]: {
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [NetworkConstants.COLLECTION_HUNTING_DISTRICT]:{
      C:true,
      R:true,
      U:true,
      D:true,
      E:true,
      I:true
    },
    [NetworkConstants.COLLECTION_GAME_COLLECT_STATION]: {
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [NetworkConstants.COLLECTION_EVENT]: {
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [NetworkConstants.COLLECTION_PERSON]: {
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [NetworkConstants.COLLECTION_DIGATAG]: {
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [NetworkConstants.COLLECTION_LABSAMPLE]: {
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [NetworkConstants.COLLECTION_TROPHY]: {
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [NetworkConstants.COLLECTION_LIFE_SIGN]: {
      C:true,
      R:true,
      U:true,
      D:true,
    }
  },
  [NetworkConstants.COLLECTION_GAMERECORD]: {
    C:false,
    R:false,
    U:false,
    D:false,
    E:false,
    I:false,
    filter: {}
  },
  [NetworkConstants.COLLECTION_HUNTING_DISTRICT]: {
    C:false,
    R:false,
    U:false,
    D:false,
    E:false,
    I:false,
    filter: {}
  },
  [NetworkConstants.COLLECTION_POI]: {
    C:false,
    R:false,
    U:false,
    D:false,
    E:false,
    I:false,
    filter: {}
  },
  [NetworkConstants.COLLECTION_WORK_ORDER]: {
    C:false,
    R:false,
    U:false,
    D:false,
    E:false,
    I:false,
    filter: {}
  },
  admin: {
    cockpit: {
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`start`]:{
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`dashboard`]:{
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`dashcadenza`]:{
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`contextsettings`]:{
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`objects`]:{
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`invitation`]:{
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`statistics`]:{
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`map`]:{
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [NetworkConstants.COLLECTION_GAMERECORD]: {
      C:true,
      R:true,
      U:true,
      D:true,
      E:true,
      I:true
    },
    [NetworkConstants.COLLECTION_POI]: {
      C:true,
      R:true,
      U:true,
      D:true,
      E:true,
      I:true
    },
    [NetworkConstants.COLLECTION_WORK_ORDER]: {
      C:true,
      R:true,
      U:true,
      D:true,
      E:true,
      I:true
    },
  },
  cockpit: {
    cockpit: {
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`start`]:{
      C:true,
      R:true,
      U:true,
      D:true,
    },
    [`dashboard`]:{
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [`dashcadenza`]:{
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [`contextsettings`]:{
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [`objects`]:{
      C:false,
      R:true,
      U:false,
      D:false,
    },
    [`invitation`]:{
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [`statistics`]:{
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [`map`]:{
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [NetworkConstants.COLLECTION_GAMERECORD]: {
      C:false,
      R:false,
      U:false,
      D:false,
      E:false,
      I:false,
      filters:[]
    },
    [NetworkConstants.COLLECTION_POI]: {
      C:false,
      R:false,
      U:false,
      D:false,
      E:false,
      I:false,
      filters:[]
    },
    [NetworkConstants.COLLECTION_WORK_ORDER]: {
      C:false,
      R:false,
      U:false,
      D:false,
      E:false,
      I:false
    },

    [NetworkConstants.COLLECTION_USER]: {
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [NetworkConstants.COLLECTION_HUNTING_DISTRICT]:{
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [NetworkConstants.COLLECTION_GAME_COLLECT_STATION]: {
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [NetworkConstants.COLLECTION_EVENT]: {
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [NetworkConstants.COLLECTION_PERSON]: {
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [NetworkConstants.COLLECTION_DIGATAG]: {
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [NetworkConstants.COLLECTION_LABSAMPLE]: {
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [NetworkConstants.COLLECTION_TROPHY]: {
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [NetworkConstants.COLLECTION_LIFE_SIGN]: {
      C:false,
      R:false,
      U:false,
      D:false,
    }
  },

  smartmap: {
    cockpit: {
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [`start`]:{
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [`dashboard`]:{
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [`dashcadenza`]:{
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [`contextsettings`]:{
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [`objects`]:{
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [`invitation`]:{
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [`statistics`]:{
      C:false,
      R:false,
      U:false,
      D:false,
    },
    [`map`]:{
      C:true,
      R:true,
      U:true,
      D:true,
    },
  },

  ansteller: {
    cockpit: {
      C:false,
      R:false,
      U:false,
      D:false,
    },
  },
  jagdleiter: {
    cockpit: {
      C:false,
      R:false,
      U:false,
      D:false,
    },
  },
  user: {
    cockpit: {
      C:false,
      R:false,
      U:false,
      D:false,
    },
  },
  hunter: {
    cockpit: {
      C:false,
      R:false,
      U:false,
      D:false,
    },
  },
  recorder:{
    cockpit: {
      C:false,
      R:false,
      U:false,
      D:false,
    },
  }
}
